import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Common.css";
import "./App.css";
import App from "./App";
import {
  ThemeProvider,
  createMuiTheme,
  createTheme,
} from "@mui/material/styles";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Route,
  Routes,
  createBrowserRouter,
} from "react-router-dom";
import Login from "./pages/login/Login";
import Router from "./Router";
import Sidebar from "./components/Sidebar";
// import ManageLoan from './pages/loans/ManageLoan';
import LoanProduct from "./pages/loans/LoanProduct";
import LoanProvider from "./pages/accounts/LoanProvider";
import Agents from "./pages/accounts/Agents";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Dealers from "./pages/accounts/Dealers";
import AgentInfo from "./pages/accounts/AgentInfo";
import Profile from "./pages/accounts/Profile";
import DealerInfo from "./pages/accounts/DealerInfo";
import LoanProviderSlots from "./pages/premium/LoanProviderSlots";
import AgentSlots from "./pages/premium/AgentSlots";
import FlooringPremium from "./pages/premium/FlooringPremium";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import AuthRoute from "./components/AuthRoute";
import DashboardLayout from "./pages/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Flooring from "./pages/Flooring";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import UserAccounts from "./pages/userAccounts";
import UserRoles from "./pages/userRoles";
import NewsLetter from "./pages/newsletter";
import NotificationLayout from "./pages/Notifications";
import FlooringNotificationLayout from "./pages/FlooringNotifications";
import NoPermission from "./pages/NoPermission";
import FlooringRates from "./pages/FlooringRates";
import FlooringVouchers from "./pages/FlooringVouchers";
import LogHistory from "./pages/LogHistory";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./helpers/ProtectedRoute";
import CustomerInfo from "./pages/accounts/CustomerInfo";
import Customers from "./pages/accounts/Customers";
import PreApproval from "./pages/preApproval";
import Enquiry from "./pages/Enquiry";
import ResetPassword from "./pages/resetPassword";

// ], { basename: '/development' });

const muiTheme = createTheme();
const theme = extendTheme({
  components: {
    Input: {
      baseStyle: {
        boxShadow: "none", // Remove the box shadow for all Input components
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={muiTheme}>
          <ChakraProvider theme={theme} resetCSS>
            <PersistGate persistor={persistor}>
              <ToastContainer position={"top-left"} />
              <BrowserRouter basename="/admin">
                {/* basename='/admin' */}
                <ScrollToTop />
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/resetpassword/:id" element={<ResetPassword />} />
                  <Route
                    path="/"
                    element={
                      <AuthRoute>
                        <DashboardLayout />
                      </AuthRoute>
                    }
                  >
                    <Route
                      index
                      element={
                        <AuthRoute>
                          <Dashboard />
                        </AuthRoute>
                      }
                    />
                    <Route path="loans">
                      <Route
                        path="loan-products"
                        element={
                          <ProtectedRoute>
                            <LoanProduct />
                          </ProtectedRoute>
                        }
                        index
                      />
                      <Route
                        path="loan-providers"
                        element={
                          <ProtectedRoute>
                            <LoanProvider />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="premium-agents" element={null} />
                    </Route>
                    <Route path="flooring">
                      <Route path="rates" element={<FlooringRates />} />
                      <Route path="vouchers" element={<FlooringVouchers />} />
                    </Route>
                    <Route path="premium">
                      <Route
                        path="loan-providers"
                        element={
                          <AuthRoute>
                            <LoanProviderSlots />
                          </AuthRoute>
                        }
                        index
                      />
                      <Route
                        path="agents"
                        element={
                          <AuthRoute>
                            <AgentSlots />
                          </AuthRoute>
                        }
                      />
                      <Route path="flooring" element={<FlooringPremium />} />
                    </Route>
                    <Route path="notifications">
                      <Route
                        path="loan/changes"
                        element={
                          <ProtectedRoute>
                            <NotificationLayout />
                          </ProtectedRoute>
                        }
                        index
                      />
                      <Route
                        path="flooring/changes"
                        element={<FlooringNotificationLayout />}
                      />
                    </Route>
                    <Route path="accounts">
                      <Route path="agents" element={<Agents />} index />
                      <Route path="profile" element={<Profile />} />
                      <Route path="agents/:id" element={<AgentInfo />} />
                      <Route path="dealers/:id" element={<DealerInfo />} />
                      <Route path="dealers" element={<Dealers />} />
                      <Route path="customers" element={<Customers />} />
                      <Route path="customers/:id" element={<CustomerInfo />} />
                    </Route>
                    <Route
                      path="user-accounts"
                      element={
                        <ProtectedRoute>
                          <UserAccounts />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="log-activities" element={<LogHistory />} />
                    <Route
                      path="user-roles"
                      element={
                        <ProtectedRoute>
                          <UserRoles />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="news-letter" element={<NewsLetter />} />
                    <Route path="pre-approval" element={<PreApproval />} />
                    <Route path="enquiry" element={<Enquiry />} />
                    <Route path="/no-permission" element={<NoPermission />} />
                    {/* <Route path="/activities" element={null} /> */}
                  </Route>
                </Routes>
              </BrowserRouter>
            </PersistGate>
          </ChakraProvider>
        </ThemeProvider>
      </Provider>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
